export interface InfoBox {
  id: number;
  name: string;
  description?: string;
}

interface Props {
  boxes: InfoBox[];
}

export default function MinisiteInfoBoxes({ boxes }: Props) {
  if (!boxes || !boxes.length) return null;

  return (
    <section className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-1 gap-3">
      {boxes.map((box) => (
        <article
          key={box.id}
          className="rounded-2xl border bg-card/90 backdrop-blur-xs p-4 flex flex-col shadow-xs hover:border-border transition-colors"
        >
          <h3 className="font-semibold text-card-foreground text-sm truncate">
            {box.name}
          </h3>
          {box.description && (
            <p className="mt-1.5 text-xs text-muted-foreground leading-relaxed line-clamp-4">
              {box.description}
            </p>
          )}
        </article>
      ))}
    </section>
  );
}
